import { Notify } from 'quasar';

export const checkNewAppRefresh = (interval) => {
  const currentVersion = process.env.BUILD_VERSION;
  setInterval(async () => {
    await fetch('/version.json', {
      method: 'GET',
      cache: 'no-cache',
    }).then((res) => res.json()).then((build) => {
      if (currentVersion !== build.version) {
        Notify.create({
          color: 'negative',
          icon: 'updated',
          message: 'The application has been updated. Please refresh the page',
          timeout: 0,
          multiLine: true,
          position: 'top',
          actions: [
            {
              label: 'Refresh',
              color: 'yellow',
              handler: () => {
                window.location.reload();
              },
            },
            {
              label: 'Dismiss',
              color: 'white',
              handler: () => {},
            },
          ],
        });
      }
    }).catch(() => {
      // Ignore errors
    });
  }, interval);
};
